<p-table [scrollable]="true" [size]="'small'" [value]="accountingAccounts()" scrollHeight="flex" stripedRows>
  <ng-template #header>
    <tr>
      <th pResizableColumn pSortableColumn="name">{{ 'accounting-account.name' | translate }}
        <p-sortIcon field="name"/>
      </th>
      <th pResizableColumn pSortableColumn="code">{{ 'accounting-account.account' | translate }}
        <p-sortIcon field="code"/>
      </th>
      <th pResizableColumn pSortableColumn="accountType">{{ 'accounting-account.type' | translate }}
        <p-sortIcon field="accountType"/>
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template #body let-row>
    <tr (click)="onRowSelect(row)" class="cursor-pointer hover:bg-gray-50">
      <td>{{ row.name }}</td>
      <td>{{ row.account }}</td>
      <td>
        @if (row.accountType) {
          {{ ('account-code-type.' + row.accountType) | translate }}
        }
      </td>
      <td class="flex justify-end">
        <elcia-button (onClick)="delete($event, row)" [icon]="'delete'" [severity]="'danger'" [variant]="'text'"/>
      </td>
    </tr>
  </ng-template>
</p-table>
